<template>
  <div
    id="nav"
    style="background-color: #333; padding: 0; margin: 0; width: 100%"
  >
    <Menu></Menu>
    <div class="header">
      <video id="video" autoplay muted loop playsinline>
        <source src="../assets/zingal.mp4" type="video/mp4" />
        <source src="../assets/zingal-webm.webm" type="video/webm" />
      </video>
      <div class="title">
        <vue-typed-js
          :strings="text"
          :loop="true"
          :backSpeed="50"
          :typeSpeed="150"
          :backDelay="2000"
          :showCursor="false"
          :smartBackspace="true"
        >
          <h1 class="typing"></h1>
        </vue-typed-js>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "./Menu";

export default {
  data() {
    return {
      text: [],
    };
  },
  components: { Menu },
  created(){
     if (localStorage.getItem("lang") === "en"){
        this.text = this.$i18n.messages.en.headerText
      } else if(localStorage.getItem("lang") ==="tr"){
        this.text = this.$i18n.messages.tr.headerText
      }
  },
};
</script>

<style scoped>
* {
   font-family: 'Sansita Swashed', cursive;
}
.header {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.header video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  object-fit: cover;
  background-color: black;
  opacity: 0.5;
  z-index: 0;
}
.header .title h1 {
  top: 10px;
  position: relative;
  text-align: center;
  font-size: 2.5em;
  color: #aeaeaf;
  z-index: 1;
  max-width: 1000px;
}
</style>
